// extracted by mini-css-extract-plugin
module.exports = {"root":"About_root__d7gIh","title":"About_title__z0p2S","linksWrapper":"About_linksWrapper__CUUg6","link":"About_link__daavZ"};